<template>
  <section class="section">
    <div class="container" style="padding-top: 60px;">
      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-10 col-lg-offset-1">
          <ul class="breadcrumbs">
            <li>Administración</li>
            <li><i class="fa fa-angle-right"></i></li>
             <li>Usuarios</li>
            <li><i class="fa fa-angle-right"></i></li>
            <li class="active">Invitar usuarios</li>
          </ul>
          <div class="box-style line-top">
            <form class="form smart-form">
            
              <!-- Agregar usuarios -->
              <div class="box-header">
                <h2>1. AGREGA LOS USUARIOS A INVITAR</h2>
              </div>
              <div class="box-body">
                <div class="row">
                  <div class="col-xs-12 col-sm-6 col-md-6 col-lg-3">
                    <div class="form-group">
                      <label>Nombre</label>
                      <input type="text" name="" class="form-control" v-model="formData.firstName" />
                      <span class="label label-danger" v-if="!$v.formData.firstName.required && mostrarErrores">Campo requerido</span>
                      <span class="label label-danger" v-if="!$v.formData.firstName.minLength && mostrarErrores">Mínimo 3 caracteres</span>
                    </div>
                  </div>
                  <div class="col-xs-12 col-sm-6 col-md-6 col-lg-2">
                    <div class="form-group">
                      <label>Apellido</label>
                      <input type="text" name="" class="form-control" v-model="formData.lastName" />
                      <span class="label label-danger" v-if="!$v.formData.lastName.required && mostrarErrores">Campo requerido</span>
                    </div>
                  </div>
                  <div class="col-xs-12 col-sm-6 col-md-6 col-lg-3">
                    <div class="form-group">
                      <label>E-mail</label>
                      <input type="mail" name="" class="form-control" v-model="formData.email" />
                      <span class="label label-danger" v-if="!$v.formData.email.required && mostrarErrores">Campo requerido</span>
                      <span class="label label-danger" v-if="!$v.formData.email.email && mostrarErrores">Formato no válido</span>
                    </div>
                  </div>
                  <div class="col-xs-12 col-sm-6 col-md-6 col-lg-2">
                    <div class="form-group">
                      <label>Rol</label>
                      <div class="select">
                        <select v-model="formData.rol">
                          <!-- <option value="-1">Elija...</option> -->
                          <option value="user">Usuario</option>
                          <option value="admincliente">Admin</option>
                        </select>
                        <i class="fa fa fa-angle-down"></i>
                      </div>
                    </div>
                  </div>
                  <div class="col-xs-12 col-sm-6 col-md-6 col-lg-2">
                    <div class="form-group no-label">
                      <button type="button" class="btn btn-fill" @click.prevent="agregarUsuario">AGREGAR</button>
                    </div>
                  </div>
                </div>
              </div><!-- fin Datos personales -->

              <div class="box-header subline-top">
                <h2>2. ENVIA LAS INVITACIONES</h2>
              </div>
              <div class="box-body">
                <div class="table-container">
                  <table class="table table-hover table-stripped table-no-first-pad">
                    <thead>
                      <tr>
                        <th>Nombre</th>
                        <th>E-mail</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="usuario, idx in usuariosAInvitar">
                        <td>{{usuario.firstName}} {{usuario.lastName}}</td>
                        <td>{{usuario.email}}</td>
                        <td>
                          <ul class="table-actions smart-form">
                            <li>
                              <a class="btn btn-xs btn-ghost" type="button" @click.prevent="editInvitado(idx)">
                                <i class="fa fa-actions fa-pencil"></i>
                              </a>
                            </li>
                            <li>
                              <a @click.prevent="removeInvitado(idx)" class="btn btn-xs btn-ghost" type="button">
                                <i class="fa fa-actions fa-times"></i>
                              </a>
                            </li>
                          </ul>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div class="form-action text-center">
                  <button @click.prevent="onClickInvitar" class="btn btn-fill">INVITAR USUARIOS</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
  import {minLength, required, email} from 'vuelidate/lib/validators'
  export default {
    data () {
      return {
        formData: {
          firstName: '',
          lastName: '',
          email: '',
          rol: 'user'
        },
        idxEdit: -1,
        mostrarErrores: false,
        usuariosAInvitar: []
      }
    },
    mounted () {

    },
    methods: {
      agregarUsuario () {
        const me = this
        me.mostrarErrores = false
        let user = {}
        if (me.$v.$invalid) {
          me.mostrarErrores = true
          return false
        }
        Object.assign(user, me.formData)
        if (me.idxEdit === -1) {
          me.usuariosAInvitar.push(user)
        } else {
          me.usuariosAInvitar.splice(me.idxEdit, 1, user)
        }
        me.clearFormData()
      },
      clearFormData () {
        const me = this
        me.formData.firstName = ''
        me.formData.lastName = ''
        me.formData.email = ''
        me.formData.rol = 'user'
        me.idxEdit = -1
      },
      editInvitado (idx) {
        const me = this
        me.idxEdit = idx
        let user = me.usuariosAInvitar[idx]
        Object.assign(me.formData, user)
      },
      onClickInvitar () {
        const me = this
        me.$http.post('/api/users/invitarusuarios', {
          invitados: me.usuariosAInvitar
        }).then((data) => {
          me.usuariosAInvitar = []
          me.$emit('mostrar-notificacion', 'Se han enviado las notificaciones', 'success')
        }, (err) => {
          console.error(err)
        })
      },
      removeInvitado (idx) {
        const me = this
        me.usuariosAInvitar.splice(idx, 1)
      }
    },
    validations: {
      formData: {
        firstName: {
          required,
          minLength: minLength(3)
        },
        lastName: {
          required
        },
        email: {
          required,
          email
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// InvitarUsuarios.vue?6295c44b